import * as types from '../ActionTypes/LeaderboardsActionTypes';

export class LeaderboardsActionCreators {
    // get profile leaderboards
    static getProfileLeaderboardsRequest = profileId => ({
        type: types.GET_PROFILE_LEADERBOARDS_REQUEST,
        meta: { profileId },
    });

    static getProfileLeaderboardsSuccess = payload => ({
        type: types.GET_PROFILE_LEADERBOARDS_SUCCESS,
        payload,
    });

    static getProfileLeaderboardsFailed = payload => ({
        type: types.GET_PROFILE_LEADERBOARDS_FAILED,
        payload,
    });

    // get workout leaderboards
    static getWorkoutLeaderboardsRequest = workoutId => ({
        type: types.GET_WORKOUT_LEADERBOARDS_REQUEST,
        meta: { workoutId },
    });

    static getWorkoutLeaderboardsSuccess = payload => ({
        type: types.GET_WORKOUT_LEADERBOARDS_SUCCESS,
        payload,
    });

    static getWorkoutLeaderboardsFailed = payload => ({
        type: types.GET_WORKOUT_LEADERBOARDS_FAILED,
        payload,
    });

    // load more profile leaderboards
    static loadMoreProfileLeaderboardsRequest = ({ profileId, paginationOffset }) => ({
        type: types.LOAD_MORE_PROFILE_LEADERBOARDS_REQUEST,
        meta: { profileId, paginationOffset },
    });

    static loadMoreProfileLeaderboardsSuccess = payload => ({
        type: types.LOAD_MORE_PROFILE_LEADERBOARDS_SUCCESS,
        payload,
    });

    static loadMoreProfileLeaderboardsFailed = payload => ({
        type: types.LOAD_MORE_PROFILE_LEADERBOARDS_FAILED,
        payload,
    });

    // load more workout leaderboards
    static loadMoreWorkoutLeaderboardsRequest = ({ workoutId, paginationOffset }) => ({
        type: types.LOAD_MORE_WORKOUT_LEADERBOARDS_REQUEST,
        meta: { workoutId, paginationOffset },
    });

    static loadMoreWorkoutLeaderboardsSuccess = payload => ({
        type: types.LOAD_MORE_WORKOUT_LEADERBOARDS_SUCCESS,
        payload,
    });

    static loadMoreWorkoutLeaderboardsFailed = payload => ({
        type: types.LOAD_MORE_WORKOUT_LEADERBOARDS_FAILED,
        payload,
    });

    // get leaderboards for slider
    static getLeaderboardsForSliderRequest = profileId => ({
        type: types.GET_LEADERBOARDS_FOR_SLIDER_REQUEST,
        meta: { profileId },
    });

    static getLeaderboardsForSliderSuccess = payload => ({
        type: types.GET_LEADERBOARDS_FOR_SLIDER_SUCCESS,
        payload,
    });

    static getLeaderboardsForSliderFailed = payload => ({
        type: types.GET_LEADERBOARDS_FOR_SLIDER_FAILED,
        payload,
    });

    // update leaderboard users
    static updateLeaderboardUsersRequest = leaderboardId => ({
        type: types.UPDATE_LEADERBOARD_USERS_REQUEST,
        meta: { leaderboardId },
    });

    static updateLeaderboardUsersSuccess = payload => ({
        type: types.UPDATE_LEADERBOARD_USERS_SUCCESS,
        payload,
    });

    static updateLeaderboardUsersFailed = payload => ({
        type: types.UPDATE_LEADERBOARD_USERS_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/LeaderboardsActionCreators.js